import { Component, OnInit } from '@angular/core';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { FAQ } from 'src/app/models/um/organization';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-faq-view',
  templateUrl: './faq-view.component.html',
  styleUrls: ['./faq-view.component.scss']
})
export class FaqViewComponent implements OnInit {
  faqs: FAQ[];
  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    public headerService: HeadService
  ) { }

  ngOnInit() {
    //debugger
    this.faqs = [];
    let modulename = "";
    let module = this.headerService.getHeader().subscribe((result)=>{
      modulename=result.module;
      this.GetModuleFAQs(modulename);
    });

  }
  GetModuleFAQs(modulename:string)
  {
    this.summaryService.getFAQByID('api/faq/getwffaqs/' + modulename).subscribe((result) => {
      this.faqs = result;
    });
  }

}
